import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet.heat";
import { Button, Card, Slider, Select } from "antd";
import Layouts from "../../../components/Layouts";

// Componente para controlar el zoom y centrado
function MapControls() {
  const map = useMap();

  return (
    <div style={{ position: "absolute", bottom: 16, right: 16, zIndex: 1000, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Button onClick={() => map.zoomIn()} shape="circle" icon={"+"} />
      <Button onClick={() => map.zoomOut()} shape="circle" icon={"-"} />
      <Button onClick={() => map.setView([40.416775, -3.70379], 13)} shape="circle" icon={"🏠"} />
    </div>
  );
}

// Componente para el mapa de calor
function HeatMapLayer({ points, radius, blur, gradient }) {
  const map = useMap();
  const heatLayerRef = useRef(null);

  useEffect(() => {
    if (!map) return;
    if (heatLayerRef.current) {
      map.removeLayer(heatLayerRef.current);
    }
    // @ts-ignore
    heatLayerRef.current = L.heatLayer(points, {
      radius,
      blur,
      gradient,
      maxZoom: 18,
    }).addTo(map);
    return () => {
      if (heatLayerRef.current) {
        map.removeLayer(heatLayerRef.current);
      }
    };
  }, [map, points, radius, blur, gradient]);

  return null;
}

// Genera datos aleatorios para el heatmap
function generateHeatMapData(center, count, radius) {
  const points = [];
  for (let i = 0; i < count; i++) {
    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * radius;
    const lat = center[0] + distance * Math.cos(angle) * 0.009;
    const lng = center[1] + distance * Math.sin(angle) * 0.012;
    const intensity = Math.random() * 0.9 + 0.1;
    points.push([lat, lng, intensity]);
  }
  return points;
}

const dataSets = {
  turismo: {
    center: [40.416775, -3.70379],
    points: 500,
    radius: 1.5,
    description: "Concentración de turistas en Madrid",
  },
  trafico: {
    center: [40.416775, -3.70379],
    points: 800,
    radius: 2,
    description: "Densidad de tráfico en Madrid",
  },
  poblacion: {
    center: [40.416775, -3.70379],
    points: 1200,
    radius: 3,
    description: "Densidad de población en Madrid",
  },
};

const gradients = {
  default: { 0.4: "blue", 0.6: "lime", 0.8: "yellow", 1.0: "red" },
  "verde-rojo": { 0.4: "green", 0.6: "yellow", 0.8: "orange", 1.0: "red" },
  "azul-morado": { 0.4: "blue", 0.6: "cyan", 0.8: "purple", 1.0: "magenta" },
  monocromo: { 0.4: "#ffffcc", 0.6: "#a1dab4", 0.8: "#41b6c4", 1.0: "#225ea8" },
};

const { Option } = Select;

export default function HealtMap() {
  const [heatMapRadius, setHeatMapRadius] = useState(25);
  const [heatMapBlur, setHeatMapBlur] = useState(15);
  const [dataSet, setDataSet] = useState("turismo");
  const [gradientType, setGradientType] = useState("default");
  const [heatMapData, setHeatMapData] = useState([]);

  useEffect(() => {
    const selectedData = dataSets[dataSet];
    const data = generateHeatMapData(selectedData.center, selectedData.points, selectedData.radius);
    setHeatMapData(data);
  }, [dataSet]);

  return (
  <Layouts>

    <div style={{ position: "relative", height: 600, width: "100%" }}>
      <MapContainer
        center={[40.416775, -3.70379]}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {heatMapData.length > 0 && (
          <HeatMapLayer
            points={heatMapData}
            radius={heatMapRadius}
            blur={heatMapBlur}
            gradient={gradients[gradientType]}
          />
        )}
        <MapControls />
      </MapContainer>
     
    </div>
      </Layouts>
  );
}
